import ActivityTypeAction from "./ActivityTypeAction";
import BaseReducer from "../../utilities/BaseReducer";

export default class ActivityTypeFilterReducer extends BaseReducer {
  initialState = {
    activityTypeFilter: [],
  };

  [ActivityTypeAction.REQUEST_ACTIVITY_TYPE_FILTER_FINISHED](state, action) {
    return {
      ...state,
      activityTypeFilter: action.payload,
    };
  }
}
